import { render, staticRenderFns } from "./cImgUploader.vue?vue&type=template&id=52016dc8&scoped=true"
import script from "./cImgUploader.vue?vue&type=script&lang=js"
export * from "./cImgUploader.vue?vue&type=script&lang=js"
import style0 from "./cImgUploader.vue?vue&type=style&index=0&id=52016dc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52016dc8",
  null
  
)

export default component.exports